// extracted by mini-css-extract-plugin
var _1 = "EmailProfile-moduleEmailProfile__gN7Lw PageWithWidgets-modulePageWithWidgets__h84KP";
var _2 = "EmailProfile-moduleactionsWidget__RZeeS Widget-moduleWidget__bcnWB";
var _3 = "EmailProfile-modulefoldersWidget__lMi92 EmailProfile-modulewidget__PbDES Widget-moduleWidget__bcnWB EmailProfileWidgetCustomFolders-modulewidget__jhPBb Widget-moduleWidget__bcnWB";
var _4 = "EmailProfile-moduleskeleton__JdVs2 Skeleton-moduleSkeleton__Mlrfv";
var _5 = "EmailProfile-modulewidget__PbDES Widget-moduleWidget__bcnWB";
export { _1 as "EmailProfile", _2 as "actionsWidget", _3 as "foldersWidget", _4 as "skeleton", _5 as "widget" }
